import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UrlServices } from 'src/app/helper/class/url-services';
import { isArray } from 'src/app/helper/class/utilityHelper';
import { AuthService } from 'src/app/helper/service/auth.service';
import { PatientsService } from 'src/app/modules/patients/service/patients.service';
import { DashboardService } from 'src/app/modules/service/dashboard.service';

@Component({
  selector: 'app-waiting-list',
  templateUrl: './waiting-list.component.html',
  styleUrl: './waiting-list.component.scss'
})
export class WaitingListComponent {
  waitingListData: any = [];
  userData = this.auth.currentUserValue;
  allToken = this.dashboardService.allToken || [];
  constructor(private patientApi: PatientsService,
    private router: Router,
    private auth: AuthService,
    private dashboardService: DashboardService,
  ) { }
  ngOnInit(): void {
    this.getData();
    this.filterWaitList();
  }
  filterWaitList() {
    if (isArray(this.allToken)) {
      const d = this.allToken.filter(a => {
        if (this.userData.is_doctor) {
          return a.doctor_fk_id == this.userData.user_id && +a.status != 1
        } else {
          return +a.status != 1;
        }
      });
      this.waitingListData = d?.length > 5 ? d?.slice(0, 10) : d;
    } else {
      this.waitingListData = [];
    }
  }
  getData() {
    this.dashboardService.dashboardVariableChanges.subscribe(v => {
      if (v.type == 'TOKEN') {
        this.allToken = v.data;
        this.filterWaitList();
      }
    })
  }
  viewPatient() {
    this.router.navigate([UrlServices.PAGE_URL.PATIENT.LIST.URL], { queryParams: {} })
  }
  viewPatientDetails(data) {
    this.router.navigate([UrlServices.PAGE_URL.PATIENT.PATIENT_TREATMENT.URL], { queryParams: { id: data?.patient_fk_id } })
  }
}